module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socket-commons/client.js
// module id = 135
// module chunks = 3